module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAALNCAIAAABhwpw4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEFJREFUeNrs1MENADAIAkDSdP+NhToGWh78z0CEJLiF5PpU1QEwLt1PnItcTh4Ty43DcyPZav7d784t7sH3PQEGAD0oTPW7GvN4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_body.png
// module id = 682
// module chunks = 51